var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsEtcOff = function SvgPartsEtcOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8 19.255v-6.51h4.16v.887H8.788v1.902h2.706v.877H8.788v1.957h3.172v.887zM16.279 13.632v5.623h-.988v-5.623H13.5v-.887h4.572v.887zM23.912 18.167q-.206.375-.512.63-.307.257-.695.385a2.6 2.6 0 0 1-.828.128q-.512 0-.941-.179a2.4 2.4 0 0 1-.768-.516 1.9 1.9 0 0 1-.366-.503 2.3 2.3 0 0 1-.187-.576 4 4 0 0 1-.07-.69 35 35 0 0 1 0-1.692q.01-.38.07-.69.06-.311.187-.576.128-.265.366-.503.338-.338.768-.516.43-.18.941-.179.906 0 1.527.512.622.512.796 1.49h-1.006a1.6 1.6 0 0 0-.444-.804q-.324-.31-.873-.31-.292 0-.54.104-.246.105-.42.288a1.3 1.3 0 0 0-.196.28q-.078.15-.12.374a5 5 0 0 0-.058.553q-.02.33-.019.823 0 .494.018.823.019.33.06.553t.119.375q.078.15.196.279.174.183.42.288.248.105.54.105.55 0 .878-.311.33-.31.448-.805h.997q-.082.486-.288.86"
  }))));
};
export default SvgPartsEtcOff;